/**
 * First-tenant firm identity — the single source of firm-specific strings
 * for the frontend.
 *
 * PRD_PHASE_1A_FIRM.md §3.2.1 (white-label data layer): no firm-specific
 * string may be hardcoded in application code. Until the tenant record
 * lands, the operating tenant's identity lives here and every page imports
 * it instead of retyping literals.
 *
 * Mirrors `backend/seed/firm_identity.py` field for field. The two files are
 * asserted equal by backend/tests/test_director_guarantee_01Sep2026.py so
 * they cannot drift.
 *
 * Values are deliberately literal (not env-resolved): they appear inside the
 * Terms of Business and inside Schedule 1, which is a personal guarantee. A
 * missing environment variable must never be able to degrade a legal
 * document to a neutral placeholder.
 */

export const FIRM = {
  name: "Bonsai Law Ltd",
  tradingName: "Bonsai Law",
  companyNumber: "13926937",
  registeredOffice:
    "The Business Terrace, Maidstone House, King Street, Maidstone, Kent ME15 6JQ",
  sraNumber: "8000734",
  vatNumber: "GB427955068",
  website: "www.bonsai.law",
  reviewUrl: "https://bonsai.law/review",
  clientCareEmail: "clientcare@bonsai.law",
  phone: "01622 804 077",
  // Complaints handler named in the Terms of Business (section 16.3). The
  // Terms must name a person and give a route to them; keeping the name and
  // address here rather than in the editorial text means a change of
  // complaints handler is a one-line tenant edit, not a Terms reissue.
  complaintsHandler: "Vanessa Challess",
  complaintsHandlerRole: "Director",
  complaintsEmail: "vanessa@bonsai.law",
  // Invoice header (BM-H — time-recording-foundations invoice engine,
  // 26 Sep 2026). Mirrors backend/hub/seed/firm_identity.py exactly.
  directLine: "01622 804077",
  residentialPropertyLine: "01622 801208",
};

export default FIRM;
